<div class="modal">
  <div class="modal-ctn picker">

    <div class="options">
      <span class="picker-title">{{ 'UI.PICK.PUMP' | translate }}</span>
      <df-input type="search" prefixIcon="heroMagnifyingGlass" allowClear (valueChange)="filter($event)" />
      <button type="button" class="icon-action" title="Close" (click)="close()"><ng-icon name="heroXMark" size="20"/></button>
    </div>

    <div class="pumps picker-list">
      @for (pump of displayedPumps; track pump) {
        <div class="pump picker-item">
          <div class="logo">
            <ng-icon name="heroCog6Tooth" size="18"/>
            <a>{{ pump.pumpId }}</a>
          </div>
          <div class="info">
            <a>{{ 'PUMP.NAME' | translate }}: {{ pump.pumpName }}</a>
            <a>{{ 'PUMP.MODEL' | translate }}: {{ pump.pumpmodelName }}</a>
          </div>
          <df-button size="sm" variant="primary" class="add" (onClick)="addPump(pump)">{{ 'UI.SELECT' | translate }}</df-button>
        </div>
      }
    </div>

  </div>
</div>